var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { PureComponent } from "react";
import { H1 } from "@irati/ui/src/Headings";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { TenantOnboardingStepStates } from "@irati/types";
import OnboardingService from "@irati/onboarding/services/onboarding";
import history from "@irati/utils/history";
import Routes, { SETUP_TENANT } from "@irati-web/app/src/routeConfig";
import Loading from "@irati/ui/src/Loading";
import tracking from "@irati-tracking/tenant-setup";
import CompleteStepFooter from "./CompleteStepFooter";
import { getNextStepPath, isValidStep } from "../../helpers";
import { Container, Content, Subtitle, SubtitleWrapper } from "./styled";
import stepDetails, { SetupSteps } from "../../constants/stepConfig";
var StepContent = /** @class */ (function (_super) {
    __extends(StepContent, _super);
    function StepContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isStepCompletable: false
        };
        _this.getStepDetails = function () {
            var _a = _this.props, stepId = _a.stepId, formatMessage = _a.formatMessage;
            var step = stepDetails[stepId];
            return {
                step_name: formatMessage({ id: step.title }),
                step_id: stepId,
                step_number: step.order
            };
        };
        _this.setIsStepCompletable = function (isStepCompletable) {
            _this.setState({ isStepCompletable: isStepCompletable });
        };
        _this.handleNextStep = function () {
            return history.push("" + Routes[SETUP_TENANT] + getNextStepPath(_this.props.stepId, _this.props.tenantOnboarding.assignedSteps));
        };
        _this.updateStepSelection = function (option) {
            var selectionId = option.selectionId, title = option.title;
            var _a = _this.props, stepId = _a.stepId, state = _a.state, existingSelection = _a.selection, formatMessage = _a.formatMessage;
            if (selectionId === existingSelection)
                return;
            var params = __assign({ option_name: formatMessage({ id: title }), option_id: selectionId }, _this.getStepDetails());
            tracking.selectOption(params);
            _this.updateStep({ stepId: stepId, state: state, selection: selectionId, routeOnComplete: false });
        };
        _this.updateStepStatus = function (state) {
            var _a = _this.props, stepId = _a.stepId, existingState = _a.state, selection = _a.selection;
            if (state === existingState)
                return;
            // CAN BE REMOVED AFTER RESET DEBUF BUTTON REMOVED
            var route = state !== TenantOnboardingStepStates.Open;
            // END
            _this.updateStep({ stepId: stepId, state: state, selection: selection, routeOnComplete: route });
            // Tracking
            var params = __assign({ option_id: selection }, _this.getStepDetails());
            if (state === TenantOnboardingStepStates.Skipped) {
                tracking.markStepSkipped(params);
            }
            if (state === TenantOnboardingStepStates.Done) {
                tracking.markStepComplete(params);
            }
            if (stepId === SetupSteps.INVITE && state === TenantOnboardingStepStates.Done) {
                tracking.finishSetup(params);
            }
            tracking.selectOption(params);
        };
        _this.updateStep = function (updateObject) {
            var stepId = updateObject.stepId, state = updateObject.state, selection = updateObject.selection, routeOnComplete = updateObject.routeOnComplete;
            var updateOnboardingSteps = _this.props.updateOnboardingSteps;
            var load = OnboardingService.updateTenantOnboardingStep(stepId, state, selection).then(function (updatedOnboarding) { return __awaiter(_this, void 0, void 0, function () {
                var nextStepPath;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, updateOnboardingSteps(updatedOnboarding.assignedSteps.filter(isValidStep))];
                        case 1:
                            _a.sent();
                            if (routeOnComplete) {
                                nextStepPath = getNextStepPath(stepId, updatedOnboarding.assignedSteps);
                                if (nextStepPath) {
                                    history.push("" + Routes[SETUP_TENANT] + nextStepPath);
                                }
                            }
                            return [2 /*return*/];
                    }
                });
            }); });
            _this.setState({ load: load });
        };
        return _this;
    }
    StepContent.prototype.componentDidMount = function () {
        tracking.viewStep(this.getStepDetails());
    };
    StepContent.prototype.render = function () {
        var _this = this;
        var _a = this.props, stepId = _a.stepId, title = _a.title, subTitle = _a.subTitle, state = _a.state, StepComponent = _a.StepComponent, selection = _a.selection, tenantOnboarding = _a.tenantOnboarding;
        var _b = this.state, load = _b.load, isStepCompletable = _b.isStepCompletable;
        return (React.createElement(Container, null,
            React.createElement(Content, null,
                React.createElement(H1, { tiny: true },
                    React.createElement(FormattedMessage, { id: title })),
                React.createElement(SubtitleWrapper, null,
                    React.createElement(Subtitle, { base: true },
                        React.createElement(FormattedMessage, { id: subTitle }))),
                React.createElement(Loading, { load: load },
                    React.createElement(StepComponent, { setIsStepCompletable: this.setIsStepCompletable, existingSelectionId: selection, handleOptionChange: this.updateStepSelection, tenantOnboarding: tenantOnboarding }))),
            React.createElement(CompleteStepFooter, { stepId: stepId, completable: isStepCompletable, state: state, handleNextStep: this.handleNextStep, handleMarkComplete: function () { return _this.updateStepStatus(TenantOnboardingStepStates.Done); }, handleSkip: function () { return _this.updateStepStatus(TenantOnboardingStepStates.Skipped); } })));
    };
    return StepContent;
}(PureComponent));
export default injectIntl(StepContent);
